// Inline 24x24 stroke icons (same drawing style as the legacy app).
const PATHS = {
  open: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
  new: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/>',
  save: '<path d="M5 3h11l4 4v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M7 3v6h8V3"/>',
  download: '<path d="M12 3v12M7 10l5 5 5-5M5 21h14"/>',
  png: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>',
  print: '<path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="8" rx="2"/><path d="M6 14h12v7H6z"/>',
  recent: '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 3v6h6"/><path d="M12 8v4l3 2"/>',
  add: '<path d="M12 5v14M5 12h14"/>',
  dup: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
  del: '<path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/>',
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
  unlock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0"/>',
  front: '<rect x="4" y="4" width="14" height="14" rx="1"/><path d="M8 8h14v14H8z" fill="currentColor" opacity="0.3"/>',
  back: '<rect x="6" y="6" width="14" height="14" rx="1"/><path d="M2 2h14v14H2z" fill="currentColor" opacity="0.3"/>',
  ruler: '<path d="M3 6h18M3 10h2M7 10h2M11 10h2M15 10h2M19 10h2"/>',
  grid: '<path d="M4 4h16v16H4zM4 10h16M4 16h16M10 4v16M16 4v16"/>',
  fit: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
  rotate: '<path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v5h-5"/>',
  undo: '<path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>',
  redo: '<path d="M15 14l5-5-5-5"/><path d="M20 9H10a6 6 0 0 0 0 12h3"/>',
  theme: '<path d="M12 3a9 9 0 1 0 0 18z" fill="currentColor"/><circle cx="12" cy="12" r="9"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.7M12 17h.01"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  error: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/>',
  warning: '<path d="M12 3.5L2.5 20h19z"/><path d="M12 10v4.5M12 17.5h.01"/>',
  field: '<path d="M5 3l5 17 2.5-7 7-2.5z"/>',
  close: '<path d="M6 6l12 12M6 18L18 6"/>',
  'align-l': '<path d="M4 4v16M8 7h11M8 12h7M8 17h11"/>',
  'align-cx': '<path d="M12 3v18M5 7h14M8 12h8M5 17h14"/>',
  'align-r': '<path d="M20 4v16M5 7h11M9 12h7M5 17h11"/>',
  'align-t': '<path d="M4 4h16M7 8v11M12 8v7M17 8v11"/>',
  'align-cy': '<path d="M3 12h18M7 5v14M12 8v8M17 5v14"/>',
  'align-b': '<path d="M4 20h16M7 5v11M12 9v7M17 5v11"/>',
  'dist-x': '<path d="M4 4v16M20 4v16M10 8v8M14 8v8"/>',
  'dist-y': '<path d="M4 4h16M4 20h16M8 10h8M8 14h8"/>',
};

/** Returns an <svg> element. */
export function icon(name, cls = 'icon-svg') {
  const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  el.setAttribute('class', cls);
  el.setAttribute('viewBox', '0 0 24 24');
  el.setAttribute('fill', 'none');
  el.setAttribute('stroke', 'currentColor');
  el.setAttribute('stroke-width', '1.5');
  el.setAttribute('stroke-linecap', 'round');
  el.setAttribute('stroke-linejoin', 'round');
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML = PATHS[name] || PATHS.add;
  return el;
}

export const FIELD_LETTER = { text: 'T', date: 'D', barcode: 'B', unsupported: '·' };
export const FIELD_ICON_CLASS = { text: 'text', date: 'date', barcode: 'barcode', unsupported: 'unknown' };
export const KIND_LABEL = { text: 'Text', date: 'Date', barcode: 'Barcode', unsupported: 'Unsupported' };
